(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["parallax-section"] && !window.DesignMode) return;
  try {
    
  window.addEventListener('scroll', throttle(parallax, 5));

  function throttle(fn, wait) {
    var time = Date.now();
    return function() {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now();
      }
    }
  };
  
  function parallax() {
    jQuery(".parallax").each(function(){
      var minScrolled = jQuery(this).parent('.parallax-container').offset().top - $(window).height();
      var scrolled = window.pageYOffset;
      // You can adjust the 0.4 to change the speed
      if(scrolled > minScrolled){
        var amount = scrolled - jQuery(this).parent('.parallax-container').offset().top;
        amount = amount.toFixed(2);
        if($(this).hasClass('front-image')){
          var coords = (amount * .8) + 'px';
        } else{
          var coords = (amount * .2) + 'px';
        }
        jQuery(this).css('transform','translateY(' + coords + ')');
      }
    });
  };
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    

  window.onload = function(){
    $('.recommended-slider').slick({
      slidesToShow: 3,
      swipeToSlide: true,
      prevArrow: '.recommended-slider-nav .prev',
      nextArrow: '.recommended-slider-nav .next',
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 449,
          settings: {
            slidesToShow: 1,
          }
        },
      ]
    });

      $(".recommended-slider .product-info").mousemove( function(e) {

        // Select hover-text element within gallery cell
        // $popup = $(this).find(".hover-text");
        
        // Get offset from top
        var eTop = $(this).offset().top;
        var eLeft = $(this).offset().left;
        
        var x = e.pageX + 20;
        var y = e.pageY;
        
        // Set CSS
        $(this).find(".hover-title").css({top: y -eTop, left: x - eLeft});
      
      });
    
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !window.DesignMode) return;
  try {
    
  $('.product-slider').slick({
    slidesToShow: 4,
    swipeToSlide: true,
    prevArrow: '.product-slider-nav .prev',
    nextArrow: '.product-slider-nav .next',
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 449,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockists"] && !window.DesignMode) return;
  try {
    

  $(function(){
    $('.stockist-accordion .stockist-country').on('click',function(){
      if($(this).siblings('.stockist-locations').hasClass('hide')){
        $('.stockist-accordion .stockist-locations').addClass('hide');
        $(this).siblings('.stockist-locations').removeClass('hide');
      } else{
        $(this).siblings('.stockist-locations').addClass('hide');
      }
    });
  });
  

  } catch(e) { console.error(e); }
})();
      })();
